import React, { Children } from 'react';
import { HeartIcon, UsersIcon, TrendingUpIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function OurMission() {
  const coreValues = ['Extreme Ownership', 'Constant and Never-Ending Improvement', 'Stewardship'];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: [0.25, 0.1, 0.25, 1]
      }
    }
  };
  return <section className="section-padding bg-white" data-id="element-794">
      <div className="container-custom" data-id="element-795">
        <div className="max-w-4xl mx-auto" data-id="element-796">
          <motion.div className="text-center mb-12" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.5
        }} data-id="element-797">
            <h2 className="mb-6" data-id="element-798">Our Mission</h2>
          </motion.div>

          <motion.div className="bg-deep-blue rounded-2xl p-12 text-center mb-12 border-2 border-deep-blue" initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          ease: [0.25, 0.1, 0.25, 1]
        }} data-id="element-799">
            <p className="text-body-large text-white leading-relaxed font-medium" data-id="element-800">
              We exist to{' '}
              <span className="text-slate font-bold" data-id="element-801">
                fix the broken recruiting cycle in D2D sales
              </span>
              . We help companies build stable, scalable teams.
            </p>
          </motion.div>

          <motion.div className="bg-gray-50 rounded-2xl p-12 mb-12 border-2 border-gray-200" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} data-id="element-802">
            <p className="text-body-large leading-relaxed mb-6" data-id="element-803">
              We believe door-to-door sales remains one of the most effective
              environments for developing grit, refined communication skills,
              leadership, and financial freedom.
            </p>
            <p className="font-semibold" data-id="element-804">We take that seriously.</p>
          </motion.div>

          <motion.div className="mb-16" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} data-id="element-805">
            <h3 className="text-center mb-8" data-id="element-806">Our Core Values</h3>
            <div className="bg-white rounded-2xl p-8 shadow-lg border-2 border-gray-200" data-id="element-807">
              <ul className="space-y-4" data-id="element-808">
                {coreValues.map((value, index) => <li key={index} className="flex items-center text-lg" data-id="element-809">
                    <span className="w-8 h-8 bg-slate/10 rounded flex items-center justify-center mr-4 flex-shrink-0" data-id="element-810">
                      <span className="text-slate font-bold" data-id="element-811">{index + 1}</span>
                    </span>
                    <span className="font-semibold text-deep-blue" data-id="element-812">
                      {value}
                    </span>
                  </li>)}
              </ul>
            </div>
          </motion.div>

          <motion.div className="grid md:grid-cols-3 gap-8" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-100px'
        }} data-id="element-813">
            <motion.div className="text-center" variants={itemVariants} data-id="element-814">
              <div className="w-16 h-16 bg-slate/10 rounded-xl flex items-center justify-center mx-auto mb-4" data-id="element-815">
                <HeartIcon className="h-8 w-8 text-slate" data-id="element-816" />
              </div>
              <h3 className="mb-3" data-id="element-817">Integrity-Driven</h3>
              <p data-id="element-818">We do the right thing, even when it's hard.</p>
            </motion.div>
            <motion.div className="text-center" variants={itemVariants} data-id="element-819">
              <div className="w-16 h-16 bg-slate/10 rounded-xl flex items-center justify-center mx-auto mb-4" data-id="element-820">
                <UsersIcon className="h-8 w-8 text-slate" data-id="element-821" />
              </div>
              <h3 className="mb-3" data-id="element-822">People-First</h3>
              <p data-id="element-823">We give young people a real shot at a career.</p>
            </motion.div>
            <motion.div className="text-center" variants={itemVariants} data-id="element-824">
              <div className="w-16 h-16 bg-slate/10 rounded-xl flex items-center justify-center mx-auto mb-4" data-id="element-825">
                <TrendingUpIcon className="h-8 w-8 text-slate" data-id="element-826" />
              </div>
              <h3 className="mb-3" data-id="element-827">Results-Focused</h3>
              <p data-id="element-828">We don't stop until the system works.</p>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}